module.exports = __webpack_public_path__ + "57f5a2690d3de81bb8473fb2ff5864f9.svg";